import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type SessionState } from '../types';

const updateTokenCase: CaseReducer<
  SessionState,
  PayloadAction<{ accessToken: string; idToken: string }>
> = (state, action) => {
  const { accessToken, idToken } = action.payload;
  const newCredentials = { ...state.credentials };
  newCredentials.accessToken = accessToken;
  newCredentials.idToken = idToken;
  state.credentials = newCredentials;
};

export { updateTokenCase };
